import templateUrl from 'emun.order/order-toc.htm'
import controller from 'emun.order/order-toc.controller'

export default {
    bindings: {
        order: '<',
        preventSubmit: '=',
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}